import { useQueries } from '@tanstack/react-query';

import { session } from '@/shared/session/session';

import { storeMembershipQueryOptions } from './use-store-products';

/** How many of the stores this person can act on sell the product, for what "Shared" means. */
export function useProductStoreCount(productId: string): number {
  const { me } = session.useSession();
  const memberships = useQueries({
    queries: (me?.stores ?? []).map((store) => ({
      ...storeMembershipQueryOptions(store.id, productId),
      enabled: productId !== '',
    })),
  });
  return memberships.filter((query) => query.data).length;
}
